export const categoryList: string[] = [
  'general',
  'business',
  'entertainment',
  'health',
  'science',
  'sports',
  'technology',
];
export const categoryListTW: string[] = [
  '焦點',
  '財金',
  '娛樂',
  '健康',
  '科技',
  '體育',
  '3C影音',
];
